module.exports = __webpack_public_path__ + "img/cooperativeMedia8.4ab7baa3.jpg";